import React from 'react';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import cn from 'classnames';
import * as selectorsSettings from 'store/services/settings/selectors';
import * as selectorsProject from 'store/services/project/selectors';
import toggleSidebar from 'store/services/settings/actions';
import * as actionsProject from 'store/services/project/actions';

import withProjectParams from 'utils/hocs/withProjectParams';
import SidebarMenu from './components/SidebarMenu';
import SidebarSwitch from './components/SidebarSwitch';
import SidebarPurge from './components/SidebarPurge';

import './style.scss';

export const Sidebar = ({
  isOpen,
  menuItems,
  currentProject,
  toggleSidebar,
  getPurgeList,
  isOpenPurgeModal,
  isLoading,
  isPurging,
  onCloseModal,
  purgeList,
  purgeProject,
  purgableDataAreEmpty,
  availablePurgableItemExists,
}) => (
  <aside styleName={cn('sidebar', { 'is-open': isOpen })}>
    <SidebarMenu
      currentProject={currentProject}
      isOpen={isOpen}
      menuItems={menuItems}
    />

    <SidebarPurge
      availablePurgableItemExists={availablePurgableItemExists}
      getPurgeList={getPurgeList}
      isLoading={isLoading}
      isOpen={isOpen}
      isOpenPurgeModal={isOpenPurgeModal}
      isPurging={isPurging}
      purgableDataAreEmpty={purgableDataAreEmpty}
      purgeList={purgeList}
      purgeProject={purgeProject}
      onCloseModal={onCloseModal}
    />

    <SidebarSwitch toggleSidebar={toggleSidebar} />
  </aside>
);

Sidebar.propTypes = {
  ...SidebarMenu.propTypes,
  ...SidebarSwitch.propTypes,
  ...SidebarPurge.propTypes,
};

const mapStateToProps = state => ({
  isPurging: selectorsProject.getIsPurging(state),
  isOpen: selectorsSettings.getSidebarIsOpen(state),
  menuItems: selectorsSettings.getMenuItems(state),
  purgeList: selectorsProject.getPurgeList(state),
  isOpenPurgeModal: selectorsProject.getIsOpen(state),
  isLoading: selectorsProject.getIsLoading(state),
  purgableDataAreEmpty: selectorsProject.checkIfPurgableDataAreEmpty(state),
  availablePurgableItemExists: selectorsProject.checkIfAvailablePurgableItemExists(
    state,
  ),
});

const mapDispatchToProps = {
  toggleSidebar,
  getPurgeList: actionsProject.getPurgeProjects,
  purgeProject: actionsProject.purgeProject,
  onCloseModal: actionsProject.closePurgeModal,
};

export default compose(
  withProjectParams,
  withProps(({ project, company }) => ({
    currentProject: {
      slug: project,
      account: company,
    },
  })),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Sidebar);
